import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "@/utils/axiosInstance";
import { Params } from "@/types";
import { handleThunkError } from "@/utils/thunkErrorHandler";

const endpoint = {
  paymentMethods: "/payment-methods",
};

export const fetchPaymentMethods = createAsyncThunk(
  "paymentMethods/fetchPaymentMethods",
  async (params: Params, thunkAPI) => {
    try {
      const response = await axiosInstance.get(endpoint.paymentMethods, {
        params,
      });
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível carregar os métodos de pagamento",
      );
    }
  },
);

export const createPaymentMethod = createAsyncThunk(
  "paymentMethods/createPaymentMethod",
  async (paymentMethodData: any, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        endpoint.paymentMethods,
        paymentMethodData,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível cadastrar o método de pagamento",
      );
    }
  },
);

export const updatePaymentMethod = createAsyncThunk(
  "paymentMethods/updatePaymentMethod",
  async (data: any, thunkAPI) => {
    try {
      const response = await axiosInstance.put(
        `${endpoint.paymentMethods}/${data.id}`,
        data,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível atualizar o método de pagamento",
      );
    }
  },
);

export const deletePaymentMethod = createAsyncThunk(
  "paymentMethods/deletePaymentMethod",
  async (id: string, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(
        `${endpoint.paymentMethods}/${id}`,
      );
      return response.data;
    } catch (error) {
      return handleThunkError(
        error,
        thunkAPI,
        "Não foi possível excluir o método de pagamento",
      );
    }
  },
);
